module.exports = __webpack_public_path__ + "img/logo_b2c.d0b2dc7d.png";